export const ORDER_MADE_FOR_LENGTH = '256';
export const SPECIAL_INSTRUCTIONS_LENGTH = '400';
